<template>
  <button
    class="nlp__button"
    :class="{
      'nlp__button--primary': primary,
      'nlp__button--primary-small': primarySmall,
      'nlp__button--secondary': secondary,
      'nlp__button--tertiary': tertiary,
      'nlp__button--fullwidth': fullWidth,
      'nlp__button--disabled': disabled,
    }"
    :disabled="disabled"
    @click="handleClick"
  >
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'NlpButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    primary: {
      type: Boolean,
      default: false,
    },
    primarySmall: {
      type: Boolean,
      default: false,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    tertiary: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('button-click');
    },
  },
}
</script>

<style scoped>
/* button */
.nlp__button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0px;
  position: relative;
  transition: all 0.3s ease;
  user-select: none;
  cursor: pointer;
}
.nlp__button span {
  position: relative;
  z-index: 3;
}


/* primary */
.nlp__button--primary {
  height: 48px;
  padding: 0 24px;
  background: #194BFB;
  border: 1px solid #fff;
  border-radius: 24px;
  font-weight: 700;
  box-shadow: 
    0px 3px 3px -1.5px #2A334614,
    0px 6px 6px -3px #2A33460A,
    0px 24px 24px -12px #0E3F7E0A;
  font-size: 16px;
  color: #fff;
}
.nlp__button--primary:after {
  content: '';
  opacity: 0;
  background: linear-gradient(95.42deg, #194BFB -35.24%, #1800D1 97.98%);
  border-radius: 24px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  transition: opacity 0.3s ease;
}
.nlp__button--primary:hover:after {
  opacity: 1;
}


/* primary small */
.nlp__button--primary-small {
  height: 40px;
  padding: 0 16px;
  background: #194BFB;
  border: 1px solid #fff;
  border-radius: 20px;
  box-shadow: 
    0px 3px 3px -1.5px #2A334614,
    0px 6px 6px -3px #2A33460A,
    0px 24px 24px -12px #0E3F7E0A;
  font-size: 14px;
  color: #fff;
}
.nlp__button--primary-small:after {
  content: '';
  opacity: 0;
  background: linear-gradient(95.42deg, #194BFB -35.24%, #1800D1 97.98%);
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  transition: opacity 0.3s ease;
}
.nlp__button--primary-small:hover:after {
  opacity: 1;
}


/* secondary */
.nlp__button--secondary {
  height: 40px;
  padding: 0 16px;
  background-color: #F4F7F9;
  border: 1px solid #fff;
  border-radius: 20px;
  box-shadow: 
    0px 1px 1px -0.5px #2A33450A,
    0px 3px 3px -1.5px #2A334614,
    0px 6px 6px -3px #2A33460A,
    0px 24px 24px -12px #0E3F7E0A;
  font-size: 14px;
  color: #5A627D;
}
.nlp__button--secondary:hover {
  background-color: #E1E5EB;
}


/* tertiary */
.nlp__button--tertiary {
  height: 40px;
  padding: 0 16px;
  background-color: #F4F7F9;
  border: 1px solid #fff;
  border-radius: 20px;
  font-size: 14px;
  color: #5A627D;
}
.nlp__button--tertiary:hover {
  background-color: #E1E5EB;
}


/* full width */
.nlp__button--fullwidth {
  display: flex;
  width: 100%;
}


/* disabled */
.nlp__button--disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>